module.exports = __webpack_public_path__ + "static/media/Check.5410420d.svg";